/**
 *
 * @module glimpseEvent
 *
 */

import UserActivityEvent from './../userActivityEvent';

/**
 *
 * @class GlimpseEvent
 *
 */
export default class GlimpseEvent extends UserActivityEvent {

    /**
     *
     * @param {String} eventUrn
     *
     */
    constructor(eventUrn) {

        super(eventUrn);

    }

}



// WEBPACK FOOTER //
// ./src/userActivity/glimpse/glimpseEvent.js